import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import * as VueGoogleMaps from 'vue2-google-maps';
import './assets/scss/styles.scss';
import i18n from './modules/i18n';
import './modules/validation';
import vuetify from './modules/vuetify';
import VueGtag from 'vue-gtag';
import JsonExcel from 'vue-json-excel';

Vue.use(VueGtag, {
  config: { id: 'UA-105640968-1' },
  appName: 'Free-Time',
  pageTrackerScreenViewEnabled: true
}, router);

Vue.component('gmap-cluster', require('vue2-google-maps/src/components/cluster').default);
Vue.component('downloadExcel', JsonExcel);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAyFb4RqH3riQX0KhCfEk4wZltfOPQTDR0',
    libraries: 'places,drawing',
    region: 'UK',
    language: 'uk'
  },
  installComponents: true
});

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
